module.exports = __webpack_public_path__ + "static/media/right.03231aea.png";